export const SERVER_ERROR_MESSAGE = 'Ops, ocorreu uma falha inesperada na aplicação.';
